<style lang="less" scoped>
.btn-right-mes {
  margin-left: 10px;
  line-height: 32px;
}

.withdrawal-mes {
  margin: 0px 0px 16px 30px;
}

/deep/ .hide .el-upload--picture-card {
  display: none;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">开票管理</div>
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">发票抬头</div>

            <div class="query-inputs-div flex-1">
              <el-input
              size="small"
                v-model="queryParam.invoicingHeaderStatusName"
                placeholder="请输入发票抬头"
              ></el-input>

            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">发票类型</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryParam.invoicingType"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              >
                <el-option label="普通发票" value="01"></el-option>
                <el-option label="增值税专用发票" value="02"></el-option>
              </el-select>
            </div>
          </div>

          <div class="list-query-child-div flex">
            <div class="query-title-div">邮箱</div>
            <div class="query-inputs-div flex-1">
              <el-input
              size="small"
                v-model="queryParam.custEmail"
                placeholder="请输入邮箱"
              ></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">申请时间</div>
            <div class="query-inputs-div flex-1">
              <!-- <el-date-picker
                class="full-width"
                v-model="searchTime"
                :picker-options="pickerOptions"
                clearable

                type="daterange"
                size="small"
                value-format="yyyy-MM-dd"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="handleDateChange"
              ></el-date-picker> -->
              <el-date-picker
                      size="small"
                      clearable
                      style="width:240px;"
                      :picker-options="pickerOptions"

                      class="mgn-lf-10"
                      v-model="searchTime"
                      value-format="yyyy-MM"
                      type="month"
                      placeholder="选择日期"
                      @change="handleDateChange"
                    >
                    </el-date-picker>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">发票状态</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryParam.invoicingStatus"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              >
                <el-option label="已作废" value="08"></el-option>
                <el-option label="待审核" value="05"></el-option>
                <el-option label="申请中" value="02"></el-option>
                <el-option label="已拒开" value="07"></el-option>
                <el-option label="已开票" value="03"></el-option>
                <el-option label="未成功" value="04"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">手机号码</div>
            <el-input
            size="small"
              v-model="queryParam.custPhone"
              placeholder="申请人手机号码"
            ></el-input>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">诺诺开票结果</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryParam.nuoNuoStatus"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              >
                <el-option label="推送成功" value="00" />
                <el-option label="推送失败" value="01" />
                <el-option label="开票完成" value="02" />
                <el-option label="发票已作废" value="03" />
                <el-option label="开票失败" value="04" />
              </el-select>
            </div>
          </div>
        </template>
        <template slot="actions">
          <button
            class="common-bg-button"
            @click="getListData(pagination, true)"
          >
            搜 索
          </button>
          <button class="common-empty-button" @click="reset()">重 置</button>
        </template>
      </ZD-list-querys>
      <!-- 表格 -->
      <div class="list-table">
        <div style="margin-bottom:20px; width: 100%; display: flex; align-items: center; justify-content: flex-start">
          <el-button
            :type="btType"
            @click="handlepS"
            :disabled="btDisabled"
          >
            批量查询
          </el-button>
          <div>
            【{{ sendFormList.today }}】推送开票结果： {{ sendFormList.yesterdayMonthAndDay }}
            新申请 {{ sendFormList.formList.newApplyCount || 0 }} 条，
            审核通过 {{ sendFormList.formList.auditPassCount || 0 }} 条，
            {{ sendFormList.todayMonthAndDay }} 共推送 {{ sendFormList.formList.pushCount }} 条
            （推送失败 {{ sendFormList.formList.pushFailCount || 0 }} 条
            【<span style="color: blue; cursor: pointer" @click="getListData(pagination, true,'01')">查看</span>】，
            开票成功 {{ sendFormList.formList.invoiceSuccCount || 0 }} 条,
            开票失败 {{ sendFormList.formList.invoiceFailCount || 0 }} 条
            【<span style="color: blue; cursor: pointer" @click="getListData(pagination, true,'04')">查看</span>】）
          </div>
        </div>
        <!-- <ZD-table
          :tableColumns="pageConfig.listColumns"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.tableConfig"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "
        ></ZD-table> -->
        <el-table
          :data="tableData"
          style="width: 100%"
          border
          stripe
          @selection-change="
            (sels) => {
              selections = sels;
              if (selections.length > 0) {
                btDisabled = false;
                btType = 'primary';
              } else {
                btDisabled = true;
                btType = 'info';
              }
            }
          "
        >
          <el-table-column type="selection" width="40" align="center" />
          <el-table-column type="index" width="40" align="center" />
          <el-table-column prop="createdWhen" label="申请时间" width="200" align="center" />
          <el-table-column prop="lastModifiedWhen" label="开票时间" width="200" align="center">
            <template slot-scope="scope">
               {{ scope.row.invoicingStatus == "03"?scope.row.lastModifiedWhen:''  }}
            </template>
          </el-table-column>
          <el-table-column prop="invoicingType" label="发票类型" width="200" align="center">
            <template slot-scope="scope">
               {{ scope.row.invoicingType == '01'?'普通发票':scope.row.invoicingType == '02'?'增值税专用发票':''  }}
            </template>
          </el-table-column>
          <el-table-column prop="invoicingHeaderStatus" label="抬头类型" width="200" align="center">
            <template slot-scope="scope">
              {{ scope.row.invoicingHeaderStatus == "01" ? "个人" : scope.row.invoicingHeaderStatus == "02" ? "企业" : "" }}
            </template>
          </el-table-column>
          <el-table-column prop="enterpriseName" label="发票抬头" width="200" align="center" />
          <el-table-column prop="taxNumber" label="税号" width="200" align="center" />
          <el-table-column prop="invoicableAmount" label="开票金额" width="200" align="center" />
          <el-table-column prop="commitRemark" label="开票备注" width="200" align="center" />
          <el-table-column prop="businessAddress" label="企业地址" width="200" align="center" />
          <el-table-column prop="enterprisePhone" label="企业电话" width="200" align="center" />
          <el-table-column prop="custEmail" label="电子邮箱" width="200" align="center" />
          <el-table-column prop="custPhone" label="申请人手机号码" width="200" align="center" />
          <el-table-column prop="lastModifiedByName" label="操作人" width="200" align="center" />
          <el-table-column prop="lastModifiedWhen" label="数据统计日期" width="200" align="center" />
          <el-table-column prop="nuoNuoStatus" label="开票结果" width="200" align="center">
            <template slot-scope="scope">
              <div>{{
                scope.row.nuoNuoStatus === '00' ? "推送成功"
                : scope.row.nuoNuoStatus === '01' ? "推送失败"
                : scope.row.nuoNuoStatus === '02' ? "开票完成"
                : scope.row.nuoNuoStatus === '03' ? "发票已作废"
                : scope.row.nuoNuoStatus === '04' ? "开票失败" : ''
                }}</div>
              <div style="color: red">失败原因：{{ scope.row.moreRemarks }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="invoicingStatus" label="开票状态" width="200" align="center">
            <template slot-scope="scope">
              {{
                scope.row.invoicingStatus == "00"
                  ? "不可开票"
                  : scope.row.invoicingStatus == "01"
                  ? "未开票"
                  : scope.row.invoicingStatus == "02"
                  ? "开票中"
                  : scope.row.invoicingStatus == "03"
                  ? "已开票"
                  : scope.row.invoicingStatus == "04"
                  ? "未成功"
                  : scope.row.invoicingStatus == "05"
                  ? "待审核"
                  : scope.row.invoicingStatus == "06"
                  ? "审核通过"
                  : scope.row.invoicingStatus == "07"
                  ? "已拒开": ""
              }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button
                @click="handleDetail(scope.row)"
                type="text"
                size="small"
                >详情</el-button
              >
              <el-button
                v-if="scope.row.invoicingStatus == '05'"
                @click="handlePass(scope.row)"
                type="text"
                size="small"
                >通过</el-button
              >
              <el-button
                v-if="scope.row.invoicingStatus == '05'"
                @click="handleRefusal(scope.row)"
                type="text"
                size="small"
                >拒开</el-button
              >
              <el-button
                v-if="scope.row.invoicingStatus == '03'"
                @click="handleVoid(scope.row)"
                type="text"
                size="small"
                >作废</el-button
              >
              <el-button
                v-if="scope.row.nuoNuoStatus == '02'"
                @click="handleDown(scope.row)"
                type="text"
                size="small"
              >下载发票</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        />
      </div>
      <el-dialog
        :title="RefusalTitle"
        :visible.sync="RefusalDialogVisible"
        width="30%"
        style="position:relaative"
      >
        <span v-if="RefusalFlag" style="position:absolute; top:5%;left:20%;">
          <el-select v-model="RefusalForm.name" placeholder="请选择拒开原因">
            <el-option label="发票和税号抬头不一致" value="01"></el-option>
            <el-option label="接受发票邮箱格式不正确" value="02"></el-option>
            <el-option label="公司相关信息不正确" value="03"></el-option>
            <el-option label="其它问题" value="04"></el-option>
          </el-select>
        </span>
        <div>
          <el-input
            type="textarea"
            :rows="6"
            placeholder="请输入内容"
            v-model="RefusalForm.RefusalTextarea"
          >
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="RefusalDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="RefusalDialog">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
import util from "@/common/util.js";
import utils from "@/utils/utils.js";
// 消息配置文件
import msgCfg from "@/config/msg.js";
// 系统配置文件
import config from "@/config/configLog.js";
import Cookies from "js-cookie";
import moment from "moment";
export default {
  data() {
    return {
      // dateKey:'',
      RefusalTitle: "",
      RefusalFlag: true,
      RefusalForm: {},
      RefusalDialogVisible: false,
      btType: "info",
      btDisabled: true,
      dealerArr: [],
      siteArr: [],
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {}, //标签页与 搜索框
      pageList: {},
      operates: {
        width: 150,
        fixed: "right",
        list: [],
      }, // 列操作按钮
      queryParam: {
        pageNum: 0,
        pageSize: config.page.pageSize,
      },
      userInfo: {}, //用户信息
      pickerMinDate: "",
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.pickerMinDate = minDate.getTime();
          //如果选中结束时间,则小于所选当前时间
          if (maxDate) {
            this.pickerMinDate = "";
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate !== "") {
            let one = 30 * 24 * 3600 * 1000;
            let minTime = this.pickerMinDate - one;
            let maxTime = this.pickerMinDate + one;
            if (maxTime > new Date()) {
              maxTime = new Date();
            }
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
          return time.getTime() > Date.now();
        },
      },
      searchTime: '', //时间
      invoicingStatus: "",
      invoicingNo: "",
      detailImgs: [],
      // 推送数据
      sendFormList: {
        yesterday: '',
        today: '',
        yesterdayMonthAndDay: '',
        todayMonthAndDay: '',
        formList: {}, // 数据项
      },
    };
  },
  methods: {
    // 获取第一天
    getCurrentMonthFirst(d) {
      var date = new Date(d);
      date.setDate(1);
      var month = parseInt(date.getMonth() + 1);
      var day = date.getDate();
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    // 获取最后一天
    getCurrentMonthLast(d) {
      var date = new Date(d);
      var currentMonth = date.getMonth();
      var nextMonth = ++currentMonth;
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      var lastTime = new Date(nextMonthFirstDay - oneDay);
      var month = parseInt(lastTime.getMonth() + 1);
      var day = lastTime.getDate();
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },

    getDate(date) {
      //date是传过来的时间戳，注意需为13位，10位需*1000
      //也可以不传,获取的就是当前时间
      if (date == null) {
        date = new Date();
      }
      var time = new Date(date);
      var year = time.getFullYear()  //年
      var month = ("0" + (time.getMonth() + 1)).slice(-2); //月
      // var day = ("0" + time.getDate()).slice(-2); //日
      var mydate = year + "-" + month;
      return mydate
    },
    getTableSection() {
      if (this.selections.length <= 0) {
        utils.error("请选择需要操作的记录");
        return;
      } else if (this.selections.length > 1) {
        utils.error("请选择一条记录进行操作");
        return;
      }
    },
    //获取运营商数据下拉框
    getDealer() {
      let _ = this;
      _.$H.post(_, _.$A.dealer.allList, {}).then((res) => {
        // console.log(res);
        _.dealerArr = res.data.data;
      });
    },
    getSite(val) {
      let _ = this;

      _.$H.post(_, _.$A.pileStation.listStationByDeal, {}).then((res) => {
        res.data.data.unshift({
          stationName: "全部电站",
        });
        _.siteArr = res.data.data;
        // console.log(_.siteArr);
      });
    },
    init() {
      this.searchTime = this.getDate()
      if (this.searchTime) {
        this.queryParam.createdWhen = `${this.getCurrentMonthFirst(this.searchTime)},${this.getCurrentMonthLast(this.searchTime)}`
      }
      this.getListData(this.pagination, true);
      // this.getDealer();
      // this.getSite();
    },
    getdealerArr(val) {
      this.dealName = val.dealName;

      this.dealNo = val.dealNo;
      // this.getSite(val.dealNo);
      // console.log(this.dealNo);
    },
    getSiteArr(val) {
      // console.log(val);
      val.forEach((item, index) => {
        if (item.indexOf("全部电站") !== -1) {
          this.stationFlag = "Y";
        } else {
          this.stationFlag = "N";
        }
      });
      // console.log(this.stationFlag);
    },
    getSerech() {
      // console.log(this.stationFlag);
      let _ = this;

      if (_.searchTime == null || _.searchTime.length == 0) {
        return _.$message.error("请选择时间区间!");
      } else if (_.stationFlag == "Y" && _.queryInfo.dealName == "") {
        //  console.log(1);
        return _.$message.error("请选择运营商!");
      } else {
        _.$U.showLoading(_);
        let obj = JSON.parse(JSON.stringify(_.queryInfo));
        obj.dtFrom += " 00:00:00";
        obj.dtTo += " 23:59:59";
        // obj.dealNo = _.dealNo;
        obj.dealName = _.dealName;
        obj.stationName = obj.stationName.join(",");
        obj.stationFlag = _.stationFlag;
        _.$H.post(_, _.$A.pileStation.StatisFilt, obj).then((res) => {
          _.tableData = res.data.data.content || [];
          _.searchTime = [];
          delete _.queryInfo.stationName;
          delete _.queryInfo.dtFrom;
          delete _.queryInfo.dtTo;
          delete _.queryInfo.isHostOperate;
          delete _.queryInfo.dealName;
          delete _.queryInfo.yoy;
          _.getListData(this.pagination, true);
          _.$U.showLoading(_);
        });
      }
    },

    handlePass(val) {
      this.$confirm("此操作将确认通过, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
                              .then(() => {
                                // obj.invoicingStatus = '06'
                                // obj.invoicingNo = val.invoicingNo;
                                // let urlk =
                                //   this.$A.Billing.requestBill + `?invoicingNo=${val.invoicingNo}`;
                                // this.$H.get(this, urlk).then((res) => {
                                //   // this.getListData(this.pagination, true);
                                //   // this.$message({
                                //   //   type: res.data.data.code == "E0000" ? "success" : "info",
                                //   //   message: res.data.data.describe,
                                //   // });
                                // });
                                let obj = {};
                                let urlP = this.$A.Billing.examine;
                                obj.invoicingNo = val.invoicingNo;
                                obj.invoicingStatus = "06";
                                this.$H.post(this, urlP, JSON.stringify(obj)).then((res) => {
                                  this.getListData(this.pagination, true);
                                  this.$message({
                                    type: "success",
                                    message: "审核通过",
                                  });
                                });
                              })
                              .catch(() => {
                                this.$message({
                                  type: "info",
                                  message: "已取消",
                                });
                              });
    },
    // 详情
    handleDetail(val) {
      console.log(val);
      localStorage.removeItem("invoicingDetail");
      this.$router.push({
        name: pageConfig.InvoicingDetail,
        query: {
          detail: val.invoicingNo,
        },
      });
      localStorage.setItem("invoicingDetail", JSON.stringify(val));
    },
    // 拒开
    handleRefusal(val) {
      this.RefusalDialogVisible = true;
      if (val.invoicingStatus == "05") {
        this.RefusalTitle = "拒开原因";
        this.RefusalFlag = true;
        this.invoicingStatus = val.invoicingStatus;
        this.invoicingNo = val.invoicingNo;
      }
    },
    // 作废
    handleVoid(val) {
      this.RefusalDialogVisible = true;
      if (val.invoicingStatus == "03") {
        this.RefusalTitle = "作废原因";
        this.RefusalFlag = false;
        this.invoicingStatus = val.invoicingStatus;
        this.invoicingNo = val.invoicingNo;
      }
    },
    RefusalDialog() {
      // console.log(this.RefusalForm.RefusalTextarea)
      let obj = {};
      if (
                              this.invoicingStatus == "03" &&
                              (this.RefusalForm.RefusalTextarea == "" ||
                                                      this.RefusalForm.RefusalTextarea == null)
      ) {
        return this.$message.error("请填写作废原因");
      }
      if (this.invoicingStatus == "03") {
        obj.invoicingStatus = "08";
        obj.invoicingNo = this.invoicingNo;
        obj.reviewRemarks = this.RefusalForm.RefusalTextarea;
      } else {
        obj.invoicingStatus = "07";
        obj.invoicingNo = this.invoicingNo;
        obj.reviewRemarks = this.RefusalForm.RefusalTextarea;
      }

      this.$H.post(this, this.$A.Billing.examine, obj).then((res) => {
        this.getListData(this.pagination, true);
      });
      this.RefusalDialogVisible = false;
    },
    // 下载发票
    handleDown(row) {
      let _ =this;
      let downloadDom = document.createElement('a');
      downloadDom.target = '_blank';
      downloadDom.href = row.invoicUrl;
      document.body.appendChild(downloadDom);
      downloadDom.click();
      document.body.removeChild(downloadDom);
    },
    /*
     *选择注册时间
     *@Api:
     *@Author:chenminghui
     *@Date: 2021-09-03 15:19:05 */
    handlepS() {
      let _ = this;
      console.log(_.selections);
      let flag = _.selections.every((item) => {
        return item.invoicingStatus == "06";
      });

      let arr = [];
      if (!flag) {
        utils.error("请选择可以查询的状态");
        arr = [];
      } else {
        _.selections.forEach((item) => {
          arr.push(item.invoicingNo);
        });
      }

      if (arr.length > 0) {
        console.log(arr);

        let invoicingNos = arr.join(",");
        let url = this.$A.Billing.queryBills + `?invoicingNos=${invoicingNos}`;
        _.$H.get(_, url).then((res) => {
          if (res.data.data) {
            _.$U.showLoading(_);
            localStorage.removeItem("detailImgs");
            _.tableData.forEach((item) => {
              res.data.data.forEach((it) => {
                if (it) {
                  if (it.invoicingNo == item.invoicingNo) {
                    item.imgUrls = it.imgUrls;
                  }
                }
              });
            });
            _.detailImgs = res.data.data;
            localStorage.setItem("detailImgs", JSON.stringify(_.detailImgs));
            _.getListData(this.pagination, true);
            console.log(_.tableData);
            // delete _.selections;
            _.$U.hideLoading(_);
            _.$message.success("查询成功");
          } else {
            _.getListData(this.pagination, true);
          }
        });
      }
    },
    handleYoy() {
      if (this.selections.length <= 0) {
        utils.error("请选择需要操作的记录");
        return;
      } else {
        let _ = this;
        _.$U.showLoading(_);
        let arr = [];
        _.selections.forEach((item) => {
          arr.push(item.staticId);
        });
        let obj = {};
        obj.staticId = arr.join(",");
        obj.yoy = "Y";

        _.$H.post(_, _.$A.pileStation.StatisBatch, obj).then((res) => {
          _.queryInfo.yoy = "Y";
          _.getListData(this.pagination, true);
          delete _.queryInfo.yoy;
          _.$U.hideLoading(_);
          _.$message.success("转换成功");
        });
      }
    },
    handleDel() {
      if (this.selections.length <= 0) {
        utils.error("请选择需要操作的记录");
        return;
      } else {
        let _ = this;
        _.$U.showLoading(_);
        let arr = [];
        _.selections.forEach((item) => {
          arr.push(item.staticId);
        });
        let obj = {};
        obj.staticId = arr.join(",");

        _.$H.post(_, _.$A.pileStation.del, obj).then((res) => {
          _.getListData(this.pagination, true);
          _.$U.showLoading(_);
          _.$message.success("删除成功");
        });
      }
    },
    handleDateChange(val) {
      console.log(val);
      if (val) {
        //  this.dateKey = val ;
        this.queryParam.createdWhen = `${this.getCurrentMonthFirst(val)},${this.getCurrentMonthLast(val)}`
      } else {
        delete this.queryParam.createdWhen
      }

      console.log(this.queryParam.createdWhen);
    },
    // 获取表格数据

    getListData(pagination, reload = false, type) {
      // 列表查询渲染
      let _ = this;
      _.$U.showLoading(_);
      _.queryParam.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 1;
        _.queryParam.pageNum = 0;
      }
      _.queryParam.pageSize = pagination.pageSize;
      _.queryParam.corpNo = "CO1524100773815";
      if (!type) {
        if (_.queryParam.invoicingHeaderStatusName === '') {
          delete _.queryParam.invoicingHeaderStatusName
        }
        if (_.queryParam.invoicingType === '') {
          delete _.queryParam.invoicingType
        }
        if (_.queryParam.custEmail === '') {
          delete _.queryParam.custEmail
        }
        if (_.queryParam.invoicingStatus === '') {
          delete _.queryParam.invoicingStatus
        }
        if (_.queryParam.custPhone === '') {
          delete _.queryParam.custPhone
        }
      } else {
        // 开票数据 - 查询 不同状态的开票数量
        _.searchTime = [];
        delete _.queryParam.createdWhen;
        _.queryParam.createdWhenFrom = _.sendFormList.yesterday + ' 00:00:00';
        _.queryParam.createdWhenTo = _.sendFormList.yesterday + ' 23:59:59';
        _.queryParam.nuoNuoStatus = type;
      }
      _.$H.post(_, config.baseUrl + _.$A.Billing.page2, JSON.stringify(_.queryParam)).then((res) => {
        _.detailImgs = localStorage.getItem("detailImgs") ? JSON.parse(localStorage.getItem("detailImgs")) : [];
        if (_.detailImgs.length > 0) {
          res.data.data.content.forEach((item) => {
            _.detailImgs.forEach((it) => {
              if (it.invoicingNo == item.invoicingNo) {
                item.imgUrls = it.imgUrls;
              }
            });
          });
        }
        _.tableData = res.data.data.content;
        _.pagination.total = res.data.data.totalElements;
        _.$U.hideLoading(_);
      });
    },
    /*
     *导出文件列表
     *@Api:post:/api/v1/dealer/export
     *@Author:chenminghui
     *@Date: 2021-09-03 15:19:05 */
    handleExport() {
      let _ = this;
      _.$U.showLoading(_);

      let arr = [];
      _.selections.forEach((item) => {
        arr.push(item.staticId);
      });
      let obj = {};
      obj.staticId = arr.join(",");
      _.$H.post(_, _.$A.pileStation.export, JSON.stringify(obj)).then((res) => {
        let filePath = res.data.data.filePath.slice(4);

        var downUrl = "http://47.100.173.53:6777" + filePath;
        // console.log(downUrl);
        window.open(downUrl, "_blank");

        _.$U.hideLoading(_);
        _.$message.success("导出成功");
      });
    },
    /*
     *点击重置按钮 ,恢复初始化页面
     *@Api:
     *@Author:chenminghui
     *@Date: 2021-09-03 15:19:05 */
    reset() {
      this.pagination.current = 1;
      this.searchTime = this.getDate()
      if (this.searchTime) {
        this.queryParam.createdWhen = `${this.getCurrentMonthFirst(this.searchTime)},${this.getCurrentMonthLast(this.searchTime)}`
      }
      delete this.queryParam.invoicingType;
      delete this.queryParam.nuoNuoStatus;
      delete this.queryParam.invoicingHeaderStatus;
      delete this.queryParam.custEmail;
      delete this.queryParam.invoicingStatus;
      delete this.queryParam.custPhone;
      delete this.queryParam.createdWhenFrom;
      delete this.queryParam.createdWhenTo;
      this.getListData(this.pagination, true);
      // this.pagination.total = 0;
    },

    // 根据时间 查询传入时间的 开票数据
    getListDataByTime() {
      let _ = this;
      _.sendFormList.today = moment().format('YYYY-MM-DD');
      _.sendFormList.todayMonthAndDay = moment().format('MM-DD');
      _.sendFormList.yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
      _.sendFormList.yesterdayMonthAndDay = moment().subtract(1, 'days').format('MM-DD');
      _.$H.post(_, _.$A.Billing.queryBillInfo, {createDay: _.sendFormList.yesterday}).then(res => {
        console.log(res.data)
        _.sendFormList.formList = res.data.data || {};
      })
    },
  },
  mounted() {
    this.init();
    this.getListDataByTime();
  },
};
</script>
